<template>
  <div class="members-page py-4 mt-4">
    <div class="container">
      <Tabs
        v-model:activeKey="activeKey"
        class="members-tabs"
        size="large"
      >
        <TabPane v-for="tab in mainTabs" :key="tab.key">
          <template #tab>
            <span class="members-tabs__tab">
              <component :is="tab.icon" v-if="tab.icon" :size="18" weight="bold" />
              {{ tab.title }}
            </span>
          </template>
          <MembersData v-if="tab.key === 'members'" />
          <MembersMail v-if="tab.key === 'mail'" />
          <MemberInvitation v-if="tab.key === 'invitation'" />
          <MembersRequests v-if="tab.key === 'requests'" />
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from 'ant-design-vue';
import {
  PhUsersThree,
  PhEnvelopeSimple,
  PhUserPlus,
  PhClipboardText,
} from 'phosphor-vue';
import MembersData from './MembersData.vue';
import MemberInvitation from './MemberInvitation.vue';
import MembersRequests from './MembersRequests.vue';
import MembersMail from './MembersMail.vue';

export default {
  components: {
    MembersData,
    MemberInvitation,
    MembersRequests,
    MembersMail,
    Tabs,
    TabPane,
    PhUsersThree,
    PhEnvelopeSimple,
    PhUserPlus,
    PhClipboardText,
  },
  data() {
    return {
      activeKey: 'members',
      mainTabs: [
        { title: 'Members', key: 'members', icon: 'PhUsersThree' },
        { title: 'Mail', key: 'mail', icon: 'PhEnvelopeSimple' },
        { title: 'Invitation', key: 'invitation', icon: 'PhUserPlus' },
        { title: 'Requests', key: 'requests', icon: 'PhClipboardText' },
      ],
    };
  },
};
</script>

<style scoped>
.members-tabs :deep(.ant-tabs-nav) {
  margin-bottom: 1.25rem;
  padding: 0.4rem;
  background: var(--color-bg-light);
  border: 1px solid var(--color-bg-dark);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  display: inline-flex;
}

.members-tabs :deep(.ant-tabs-nav::before) {
  border-bottom: none;
}

.members-tabs :deep(.ant-tabs-nav-list) {
  gap: 0.25rem;
}

.members-tabs :deep(.ant-tabs-tab) {
  font-size: 1rem;
  font-weight: 500;
  color: var(--color-text-light);
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 8px;
  transition: color 0.2s ease, background 0.2s ease;
}

.members-tabs :deep(.ant-tabs-tab .ant-tabs-tab-btn) {
  padding: 0.6rem 1.4rem;
  display: inline-flex;
  align-items: center;
}

.members-tabs :deep(.ant-tabs-tab:hover) {
  color: var(--color-primary);
  background: var(--color-primary-outline);
}

.members-tabs :deep(.ant-tabs-tab-active) {
  background: var(--color-primary);
}

.members-tabs :deep(.ant-tabs-tab-active .ant-tabs-tab-btn),
.members-tabs :deep(.ant-tabs-tab-active:hover .ant-tabs-tab-btn) {
  color: #fff !important;
  font-weight: 600;
}

.members-tabs :deep(.ant-tabs-ink-bar) {
  display: none;
}

.members-tabs__tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 640px) {
  .members-tabs :deep(.ant-tabs-nav) {
    padding: 0.3rem;
  }

  .members-tabs :deep(.ant-tabs-tab) {
    font-size: 0.9rem;
  }

  .members-tabs :deep(.ant-tabs-tab .ant-tabs-tab-btn) {
    padding: 0.5rem 1rem;
  }
}
</style>
